import { useState } from 'react';
import PageLayout from '../../components/ui/PageLayout';
import Orders from './Orders';
import OrderItemTimes from './OrderItemTimes';
import { useData } from '@/hooks/useData';
import { useAuth } from '@/hooks/useAuth';

export default function OrdersDashboard(): JSX.Element {
  const [activeTab, setActiveTab] = useState<'revenue' | 'itemTimes' >('revenue');
  const {
      userFranchises,
    } = useData();
  const { user } = useAuth();
  const isMultiFranchise = !!userFranchises?.some((f) => f.id === '29') && !!userFranchises?.some((f) => f.id === '59');
  const isJohn = user?.attributes.email.includes("johnmackey");
  const hasItemTimeAccess =  isMultiFranchise || isJohn;


  return (
    <PageLayout title="Loss Prevention">
        <div className="bg-white dark:bg-slate-900 rounded-xl shadow p-4">
          <div className="flex space-x-4 border-b border-gray-200 dark:border-gray-700">
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === 'revenue'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-600 dark:text-gray-300'
              }`}
              onClick={() => { setActiveTab('revenue'); }}
            >
              Revenue
            </button>
            <button
               className={`px-4 py-2 text-sm font-medium ${
              activeTab  === 'itemTimes'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : !hasItemTimeAccess
                  ? 'text-gray-500 dark:text-gray-500' // This is the 'if true' part of the inner ternary
                  : 'text-gray-600 dark:text-gray-300' // This is the 'if false' part
            }`}
              onClick={() => { setActiveTab('itemTimes'); }}
              disabled={!hasItemTimeAccess}
            >
              Item Times
            </button>
          </div>
        </div>
        <div className="mt-4">
          {activeTab === 'revenue' && <Orders />}
          {activeTab === 'itemTimes' && <OrderItemTimes />}
        </div>
    </PageLayout>
  );
}
